import { connect } from 'react-redux';
import { selectors as assetsSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/assets';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { CONSISTENT_NAVIGATION_ENABLED } from '~/domains/featureFlags/keys';
import DeprecationHeader from './DeprecationHeader';

const mapStateToProps = (state, { asset }) => {
  return {
    asset,
    isMinorDeprecated: assetsSelectors.isMinorDeprecated(state, asset),
    isConsistentNavigationEnabled: featureFlagsSelectors.featureFlag(
      state,
      CONSISTENT_NAVIGATION_ENABLED
    )
  };
};

export default connect(mapStateToProps)(DeprecationHeader);
